export default __webpack_public_path__ + "src/assets/icn-more.6049c5afda55cc06b838a93834238a0e.svg";